import type { ChatEmoticonItem } from '@module/apis/client-side/chat-emoticon/type';
import type { NormalChatMessage, NormalChatMessageType } from '../../types/centrifuge/public-message';
import type { FanLevel } from '../../types/centrifuge/publicMessageTypes';
import { checkIsMobile } from '../../utils/checkIsMobile';

export interface CreateFakeChatMessageParams {
  isManager: boolean;
  isRoomMaster: boolean;
  fanLevel: FanLevel;
  fanRank: number;
  userId: string;
  userGender: 'M' | 'F' | 'U';
  userIdx: number;
  userNick: string;
  message: string;
  blockEmoticon: ChatEmoticonItem | null;
}

const getChatMessageType = (isManager: boolean, isRoomMaster: boolean): NormalChatMessageType => {
  if (isRoomMaster) return 'bj';
  if (isManager) return 'manager';
  return 'chatter';
};

/**
 * 광고성 채팅일 경우 실제 전송하지 않고 가짜 채팅 메시지를 생성합니다.
 */
export const createFakeChatMessage = (params: CreateFakeChatMessageParams): NormalChatMessage => {
  const { isManager, isRoomMaster, fanLevel, fanRank, userId, userGender, userIdx, userNick, message, blockEmoticon } =
    params;

  const type = getChatMessageType(isManager, isRoomMaster);
  const now = Date.now();

  return {
    data: {
      type,
      lev: fanLevel,
      rk: fanRank,
      message,
      emoticon: blockEmoticon ? { block: blockEmoticon, inline: null } : null,
      created_at: now,
      id: userId,
      sex: userGender === 'M' ? 'M' : 'F',
      idx: userIdx,
      nk: userNick,
      dt: checkIsMobile() ? 'webMobile' : 'webPc',
      pf: 'wpm',
      iat: now,
      ip: '',
      lang: ['ko'],
    },
    offset: now,
  };
};
